(() => {
  document.addEventListener("click", (event) => {
    const arrow = event.target.closest("[data-mc-related-prev], [data-mc-related-next]");
    if (!arrow) return;

    const wrapper = arrow.closest(".cart_upsell_wrapper");
    const track = wrapper?.querySelector("[data-mc-related-track]");
    if (!track) return;

    const direction = arrow.hasAttribute("data-mc-related-prev") ? -1 : 1;
    track.scrollBy({
      left: direction * Math.max(track.clientWidth * 0.86, 240),
      behavior: "smooth",
    });
  });

  const createShortDateFormatter = (locale) => new Intl.DateTimeFormat(locale || document.documentElement.lang || "it-IT", {
    day: "numeric",
    month: "short",
  });

  const addBusinessDays = (date, days) => {
    const result = new Date(date);
    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
    }

    return result;
  };

  const firstShippingDay = (date) => {
    const result = new Date(date);
    while (result.getDay() === 0 || result.getDay() === 6) {
      result.setDate(result.getDate() + 1);
    }
    return result;
  };

  const addCalendarDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const updateDeliveryEstimate = (root = document) => {
    const estimate = root.querySelector("[data-mc-delivery-estimate]");
    if (!estimate) return;

    const locale = estimate.dataset.locale || document.documentElement.lang || "it-IT";
    const deliveryPrefix = estimate.dataset.deliveryPrefix || "";
    const shortDate = createShortDateFormatter(locale);
    const today = new Date();
    const preparationStart = firstShippingDay(today);
    const preparationEnd = addBusinessDays(preparationStart, 1);
    const deliveryStart = firstShippingDay(addCalendarDays(preparationStart, 2));
    const deliveryEnd = firstShippingDay(addCalendarDays(preparationStart, 5));

    const orderDate = estimate.querySelector("[data-mc-order-date]");
    const preparationWindow = estimate.querySelector("[data-mc-preparation-window]");
    const deliveryWindow = estimate.querySelector("[data-mc-delivery-window]");

    if (orderDate) orderDate.textContent = shortDate.format(today);
    if (preparationWindow) {
      preparationWindow.textContent =
        `${shortDate.format(preparationStart)}–${shortDate.format(preparationEnd)}`;
    }
    if (deliveryWindow) {
      deliveryWindow.textContent =
        `${deliveryPrefix} ${shortDate.format(deliveryStart)}–${shortDate.format(deliveryEnd)}`.trim();
    }
  };

  document.addEventListener("DOMContentLoaded", () => updateDeliveryEstimate());
  window.addEventListener("cart:updated", () => updateDeliveryEstimate());
  document.addEventListener("cart:refresh", () => updateDeliveryEstimate());
})();
